// extracted by mini-css-extract-plugin
export var offlineNotificaton = "d5_Jy";
export var offlineNotificaton__button = "d5_JC";
export var offlineNotificaton__header = "d5_JB";
export var offlineNotificaton__text = "d5_JD";
export var offlineNotificaton__withCookie = "d5_Jz";